<template>
  <a-form-item v-bind="fiConfig">
    <template slot="label">
      {{label}}
    </template>
    <a-select v-if="!hasMultipleRows" v-bind="slConfig" @change="handleChange" v-decorator="decorator||[]" :disabled="disabled">
      <a-select-option v-for="d in options" :key="d.value">{{d.text}}</a-select-option>

      <template v-for="customSlot in customSlots" :slot="customSlot">
        <slot :name="customSlot"></slot>
      </template>
    </a-select>

    <a-row v-if="hasMultipleRows">
      <a-col span="22">
        <a-select v-bind="slConfig" @change="handleChange" v-decorator="decorator||[]" :disabled="disabled">
          <a-select-option v-for="d in options" :key="d.value">{{d.text}}</a-select-option>

          <template v-for="customSlot in customSlots" :slot="customSlot">
            <slot :name="customSlot"></slot>
          </template>
        </a-select>
      </a-col>
      <a-col span="2">
        <dropdown-large :endpoint="endpoint"
                        :rowKey="this.rowKey"
                        :columns="this.columns"
                        :saveValue="this.saveValue"
                        @model="modeloRecibido"
                        :params="params"
                        style="width: 100%"></dropdown-large>
      </a-col>
    </a-row>
  </a-form-item>
</template>
<script>
  import JsUtils from '@/util/JsUtils'
  import JqHttpUtil from '@/util/JqHttpUtil'

  export default {
    props: ['label', 'selectedObj', 'placeholder', 'endpoint', 'decorator', 'rowKey', 'columns', 'saveValue', 'hasMultipleRows',
      'selectConfig', 'formItemConfig', 'cache', 'params', 'disabled', 'count', 'customSlots'],
    data () {
      return {
        slConfig: {
          showSearch: Array.isArray(this.options) && this.options.length > 5,
          placeholder: this.placeholder || 'Seleccione una opción',
          defaultActiveFirstOption: true,
          allowClear: true,
          filterOption: this.filterOption
        },
        fiConfig: {
          'label-col': {span: 3},
          'wrapper-col': {span: 21},
          'has-feedback': true
        },
        options: [],
        iValue: undefined
      }
    },
    beforeMount () {
      this.slConfig = {...this.slConfig, ...this.selectConfig}
      this.fiConfig = {...this.fiConfig, ...this.formItemConfig}
    },
    mounted () {
      /* descarga los datos */
      this.http = new JqHttpUtil(this.endpoint + '/dropdown')
      this.loadOptions()
    },
    methods: {
      modeloRecibido (value) {
        this.$emit('model', value)
      },
      handleChange (value) {
        this.iValue = value
        this.$emit('change', value)
        if (JsUtils.isEmpty(value)) {
          this.$emit('update:selectedObj', {})
          return
        }

        let fnUpdate = (value) => {
          if (this.slConfig.loading) {
            setTimeout(() => {
              fnUpdate(value)
            }, 100)
          } else {
            this.updateSelectedObj(value)
          }
        }
        fnUpdate(value)
      },
      updateSelectedObj (value) {
        for (let i = 0; i < this.options.length; i++) {
          let option = this.options[i]
          if (option.value === value) {
            this.$emit('update:selectedObj', option)
            return
          }
        }
      },
      loadOptions () {
        if (this.slConfig.loading) return
        this.loading(true)
        this.options = []
        this.http.get(this.params || {}, {
          cache: typeof this.cache === 'undefined' ? true : this.cache
        }, (response) => {
          this.options = response.data
          this.updateSelectedObj(this.iValue)
        }, (error) => {
          this.options = [{value: '', text: 'Error consultando lista'}]
        }).always(() => {
          this.loading(false)
        })
      },
      loading (loading) {
        this.slConfig.loading = loading
        this.slConfig.disabled = loading
        this.slConfig.allowClear = !loading
        this.slConfig.showSearch = Array.isArray(this.options) && this.options.length > 5
        this.slConfig = {...this.slConfig}
      },
      filterOption (input, option) {
        return (
          option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
        )
      },
      clearValue () {
        if (!this.decorator) {
          this.slConfig.value = undefined
          this.slConfig = {...this.slConfig}
          this.$nextTick(() => {
            delete this.slConfig.value
          })
        }
        this.handleChange(undefined)
      }
    },
    watch: {
      params (newValue, oldValue) {
        if (JsUtils.isEqual(newValue, oldValue)) {
          return
        }
        this.loading(false)
        this.loadOptions()
        this.clearValue()
      },
      options () {
        this.$emit('update:count', this.options.length)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/components/ui/dropdown.vue